<mat-card class="question-card center">
  <mat-card-content>
    <mat-label class="mat-title question-text">{{title}}</mat-label>
    <div *ngIf="text">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="right-aligned-header">
          <mat-panel-title></mat-panel-title>
          <mat-panel-description>
            {{toggleText}}
          </mat-panel-description>         
        </mat-expansion-panel-header>       
        <p>{{text}}</p>       
      </mat-expansion-panel>
    </div>
    <div class="clearfix"></div>
    <div *ngIf="ctrl">
      <mat-error *ngIf="invalid">
        <div *ngIf="ctrl.errors.required" [innerHTML]="requiredErrorMessage"></div>
      </mat-error>
    </div>
    <input *ngIf="categories.length>5" type="text" class="form-control" placeholder="Search Here" [(ngModel)]="searchText">
    <div [formGroup]="form">
      <mat-radio-group formControlName="{{question.name}}">
        <div *ngFor="let category of categories | searchOptionFilter:searchText:['name']; let i = index" class="form-control">
          <mat-radio-button #radio color="primary" [value]="category.code">

            <span *ngIf="!category.isOther" class="category-text">{{category.rightText}}</span>

            <mat-form-field *ngIf="category.isOther">
              <input #other matInput placeholder="{{category.rightText}}" formControlName="{{question.name}}_{{category.code}}_other" />
            </mat-form-field>
          </mat-radio-button>
        </div>
      </mat-radio-group>

    </div>
  </mat-card-content>
</mat-card>
